import React from 'react';
import { useState } from 'react';
import { usePath, useBreadcrumbs } from '../../hooks';
import { useTeam, useTeamGames, useSeason } from '../shared/hooks';
import { useFilteredLineupExplorerAnalysis } from './useLineupExplorerAnalysis';
import { LineupExplorer } from './LineupExplorer';
import { usePlayersFilter } from './PlayersFilter/usePlayersFilter';
import { useLineupsFilter } from './LineupsFilter/useLineupsFilter';
import { useDisplayFilter } from './DisplayFilter/useDisplayFilter';
import { seasonName, teamName } from '../../lib/format';
import { isArray } from 'util';

const LineupExplorerPage = ({ leagueId, seasonId, teamId, lineupId }) => {
  const team = useTeam(teamId);
  const season = useSeason(seasonId);
  const [gameId, setGameId] = useState(null);
  // this is the analysis without filters. It's used to get the players and ranges
  const baseAnalysis = useFilteredLineupExplorerAnalysis(
    leagueId,
    seasonId,
    teamId,
  );
  const filter = useLineupsFilter(leagueId, team, baseAnalysis);
  const players = usePlayersFilter(baseAnalysis);
  const filteredAnalysis = useFilteredLineupExplorerAnalysis(
    leagueId,
    seasonId,
    teamId,
    gameId,
    filter,
    players,
  );
  const display = useDisplayFilter(lineupId, filteredAnalysis);
  const games = useTeamGames(
    leagueId,
    seasonId,
    team,
    null,
    150,
    true,
    false,
    filter.division.value,
    filter.conference.value,
  );

  const formatGameId = value => {
    if (isArray(value)) {
      value = value.map(mapped => mapped.value).join(',');
    }
    setGameId(value);
  };

  // Determine if the team is an NBA team which affects filter labels
  const checkIfNBA = team => {
    const nbaLeague = team.leagues.find(l =>
      l.name.toLowerCase().includes('nba'),
    );
    return nbaLeague ? true : false;
  };
  const isNBA = team && checkIfNBA(team);

  const pathTo = usePath(leagueId, seasonId, teamId);
  useBreadcrumbs(createBreadcrumbs, [team, season, pathTo]);
  return (
    <LineupExplorer
      team={team}
      games={games}
      season={season}
      lineupId={lineupId}
      pathTo={pathTo}
      analysis={filteredAnalysis}
      filter={filter}
      players={players}
      display={display}
      onHandleGameChange={formatGameId}
      isNBA={isNBA}
    />
  );
};

export default LineupExplorerPage;

function createBreadcrumbs(team, season, pathTo) {
  if (!team) return;

  return [
    { title: 'Teams', url: pathTo('teams') },
    { title: `[${seasonName(season)}] ${teamName(team)}`, url: pathTo('team') },
    { title: 'Lineups', url: pathTo('lineups') },
    { title: 'Lineup Explorer' },
  ];
}
